import type { SkedEnvConfig } from "./types";
import devConfig from "./env.dev";
import stagingConfig from "./env.staging";
import productionConfig from "./env.production";

const configs: Record<string, SkedEnvConfig> = {
  development: devConfig,
  dev: devConfig,
  staging: stagingConfig,
  production: productionConfig,
};

const env = process.env.NODE_ENV || "development";
const config: SkedEnvConfig = configs[env] || devConfig;

(window as any).__SKED_CONFIG__ = {
  ...config,
  env,
  buildVersion: process.env.SKED_APP_BUILD_HASH || "unknown",
};

export default config;
export type { SkedEnvConfig };
